import type { DropTimelineContext, DropTimelinePickTarget } from '@/features/siem/utils/drop-timeline';

function ctxFromPick(t: DropTimelinePickTarget): DropTimelineContext {
  return {
    ...(t.uniqueId != null ? { uniqueId: t.uniqueId } : {}),
    ...(t.wiserDropId != null ? { wiserDropId: t.wiserDropId } : {}),
    ...(t.preparedDropId != null ? { preparedDropId: t.preparedDropId } : {}),
  };
}

export function timelineModalHasQueryableId(c: DropTimelineContext): boolean {
  const uid = c.uniqueId?.trim() ?? '';
  const prep = c.preparedDropId?.trim() ?? '';
  const wid = c.wiserDropId;
  return (
    uid.length > 0 ||
    prep.length > 0 ||
    (wid != null && Number.isInteger(wid) && wid >= 1)
  );
}

/** Resolves which drop to load after optional multi-drop pick step. */
export function effectiveDropTimelineContext(
  raw: DropTimelineContext | null,
  picked: DropTimelinePickTarget | null,
): DropTimelineContext | null {
  if (!raw) return null;
  const list = raw.pickTargets ?? [];
  if (picked != null) return ctxFromPick(picked);
  if (list.length > 1) return null;
  if (list.length === 1) return ctxFromPick(list[0]);
  return {
    ...(raw.uniqueId != null ? { uniqueId: raw.uniqueId } : {}),
    ...(raw.wiserDropId != null ? { wiserDropId: raw.wiserDropId } : {}),
    ...(raw.preparedDropId != null ? { preparedDropId: raw.preparedDropId } : {}),
  };
}

export function shouldShowDropTimelineModal(payload: DropTimelineContext | null): boolean {
  if (!payload) return false;
  const picks = payload.pickTargets?.length ?? 0;
  if (picks > 1) return true;
  const eff = effectiveDropTimelineContext(payload, null);
  return eff != null && timelineModalHasQueryableId(eff);
}
